var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.35 11.1095V8.8189L17.5785 7.90265L16.9357 6.34216L18.1928 3.70795L16.5785 2.09019L13.9928 3.39299L12.4357 2.74875L11.45 0H9.16426L8.26426 2.77738L6.67855 3.42162L4.04998 2.16178L2.43569 3.77953L3.73569 6.37079L3.09283 7.93128L0.349976 8.9048V11.1811L3.1214 12.0974L3.76426 13.6578L2.50712 16.2921L4.1214 17.9098L6.70712 16.607L8.26426 17.2513L9.24998 20H11.5214L12.4214 17.2226L14.0071 16.5784L16.6357 17.8382L18.25 16.2205L16.9357 13.6292L17.6071 12.0687L20.35 11.0809V11.1095ZM10.35 14.3021C7.97855 14.3021 6.06426 12.3837 6.06426 10.0072C6.06426 7.63064 7.97855 5.71224 10.35 5.71224C12.7214 5.71224 14.6357 7.63064 14.6357 10.0072C14.6357 12.3837 12.7214 14.3021 10.35 14.3021Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSetting);
export default __webpack_public_path__ + "static/media/icon_setting.0cd6cb937eaa4bd86f25864870934c48.svg";
export { ForwardRef as ReactComponent };